import { render, staticRenderFns } from "./SearchJobItem.vue?vue&type=template&id=b5389212&scoped=true"
import script from "./SearchJobItem.vue?vue&type=script&lang=js"
export * from "./SearchJobItem.vue?vue&type=script&lang=js"
import style0 from "./SearchJobItem.vue?vue&type=style&index=0&id=b5389212&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5389212",
  null
  
)

export default component.exports